import { useSearchParams } from "react-router-dom";
import { WizardLayout } from "@/components/plan/WizardLayout";
import { ServiceSelector } from "@/components/plan/ServiceSelector";
import { WeddingQuoteBranch } from "@/components/plan/WeddingQuoteBranch";
import { VenueInquiryBranch } from "@/components/plan/VenueInquiryBranch";
import { isPlanService, type PlanService } from "@/lib/plan-wizard-schema";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function PlanWizardPage() {
  const [params, setParams] = useSearchParams();

  const serviceParam = params.get("service");
  const service: PlanService | null = isPlanService(serviceParam) ? serviceParam : null;
  const menuId = params.get("menu_id");

  useDocumentMeta({
    title: "Plan Your Event | Tristano's Catering",
    description:
      "Tell us about your event — wedding, corporate, drop-off, venue booking, or live chef service — and we'll take it from there.",
  });

  const selectService = (next: PlanService) => {
    const nextParams = new URLSearchParams(params);
    nextParams.set("service", next);
    setParams(nextParams, { replace: false });
  };

  if (!service) {
    return (
      <WizardLayout
        hideBack
        title="Plan Your Event"
        subtitle="What kind of event are you planning? Pick one to get started."
      >
        <ServiceSelector onSelect={selectService} />
      </WizardLayout>
    );
  }

  // Form first for every service (#1221); submit lands on the service's menu.
  if (service === "venue") {
    return (
      <WizardLayout>
        <VenueInquiryBranch />
      </WizardLayout>
    );
  }

  // Keyed by service: the form captures `service` and the partial-lead refs at
  // mount, so a history hop between two quote services must remount it.
  return (
    <WizardLayout>
      <WeddingQuoteBranch key={service} service={service} menuId={menuId} />
    </WizardLayout>
  );
}
